export default function(product){
    return `Cena ${product} na pijaci`;
}
